module.exports = __webpack_public_path__ + "media/images/icons/facebook-icon-4d4460260f64103d8da4a91d8e856d36.svg";